import { X } from 'lucide-react';
import { useStore } from '../../../../hooks/useStore';
import styles from './NewOvertimePopup.module.css';

const RejectionReasonPopup = () => {
  const { popupStore, overtimeStore } = useStore();

  const handleClose = () => {
    popupStore.setIsRejectionReasonOpen(false);
    overtimeStore.setSelectedOvertime(null);
  };

  const selectedOvertime = overtimeStore.selectedOvertime;

  if (!selectedOvertime || !selectedOvertime.rejectionReason) {
    return null;
  }

  return (
    <div className={styles.popupOverlay} onClick={handleClose}>
      <div
        className={styles.popupContent}
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className={styles.popupHeader}>
          <h3 className={styles.popupTitle}>Red Sebebi</h3>
          <button className={styles.closeButton} onClick={handleClose}>
            <X size={20} />
          </button>
        </div>

        <div style={{ padding: '20px' }}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Red Sebebi</label>
            <div
              style={{
                padding: '12px',
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                border: '1px solid #e0e0e0',
                minHeight: '100px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {selectedOvertime.rejectionReason}
            </div>
          </div>

          <div className={styles.buttonGroup} style={{ marginTop: '20px' }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 20px',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500,
              }}
              onMouseOver={e => (e.currentTarget.style.backgroundColor = '#1565c0')}
              onMouseOut={e => (e.currentTarget.style.backgroundColor = '#1976d2')}
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionReasonPopup;
